import {
  ACCEPT_LOAN,
  APPLICATION_UNDER_REVIEW,
  APPROVED,
  JOINT_APPLICATION,
  SUBMITTED,
  instantApprovalProducts,
  productIds,
} from '../../utils';
import { ApplicationSubmissionStatus, StatusStep, StepType, Steps } from './types';

export const getInitialSteps = (
  isJointForm: boolean,
  hasJoint: boolean,
  status?: ApplicationSubmissionStatus,
): Steps => {
  if (status === ApplicationSubmissionStatus.APPROVED) {
    return [
      {
        title: APPROVED.TITLE,
        key: StatusStep.APPROVED,
      },
    ];
  }

  return [
    {
      title: isJointForm || hasJoint ? SUBMITTED.TITLE_JOINT : SUBMITTED.TITLE,
      key: StatusStep.SUBMITTED,
    },
    {
      title: APPLICATION_UNDER_REVIEW.TITLE,
      content: APPLICATION_UNDER_REVIEW.CONTENT,
      key: StatusStep.APPLICATION_UNDER_REVIEW,
    },
  ];
};

export const getStatusSteps = ({
  isJointForm,
  financialProductId,
  jointApplicantName,
  applicationStatus,
  isCashApplication,
}: {
  isJointForm: boolean;
  financialProductId: string;
  jointApplicantName?: string;
  applicationStatus?: ApplicationSubmissionStatus;
  isCashApplication?: boolean;
}): Steps => {
  const hasJointOrIsJoint = !!jointApplicantName || isJointForm;
  const isBrightePay = financialProductId === productIds.BRIGHTE_PAY;

  const steps: Steps = [];

  const hideJointStep = isBrightePay
    ? applicationStatus === ApplicationSubmissionStatus.APPROVED
    : applicationStatus === ApplicationSubmissionStatus.APPROVED ||
      applicationStatus === ApplicationSubmissionStatus.REFERRED;

  if (hasJointOrIsJoint && !hideJointStep) {
    steps.push({
      title: isJointForm ? JOINT_APPLICATION.SUBMITTED_TITLE : JOINT_APPLICATION.TITLE,
      content: isBrightePay
        ? JOINT_APPLICATION.JOINT_APPLICATION_PENDING
        : JOINT_APPLICATION.description(jointApplicantName),
      key: StatusStep.JOINT_APPLICATION,
    });
  }

  if (!instantApprovalProducts.includes(financialProductId) && !isCashApplication) {
    // content (active state) only ever shows once approved; description (upcoming state) shows
    // while under review — deliberately different tenses, not the same string reused.
    steps.push({
      title: ACCEPT_LOAN.TITLE,
      content: hasJointOrIsJoint ? ACCEPT_LOAN.JOINT_APPROVED_DESCRIPTION : ACCEPT_LOAN.APPROVED_DESCRIPTION,
      description: hasJointOrIsJoint ? ACCEPT_LOAN.JOINT_DESCRIPTION : ACCEPT_LOAN.DESCRIPTION,
      descriptionSize: 'standard' as const,
      key: StatusStep.ACCEPT_LOAN_CONTRACT,
    });
  }

  return steps;
};

export const getStepIndexByKey = (key: StatusStep, steps: Steps): number => {
  return steps.findIndex((step: StepType) => step.key === key);
};
